import { GuestSegmentTypes } from '../guestSegment/guestSegment.types';
import { OrderSource } from '../ticket/ticket.types';

export enum DurationTypes {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
}

export enum StatisticTypes {
  OVERVIEW = 'Overview',
  SEGMENTS = 'Segments',
  SOCIALS = 'Socials',
  CAMPAIGNS = 'Campaigns',
  REVIEWS = 'Reviews',
}

export enum EmailSmsTypes {
  EMAILS_SENT = 'Emails Sent',
  EMAILS_FAILED = 'Emails Failed',
  SMS_SENT = 'SMS Sent',
  SMS_FAILED = 'SMS Failed',
}

export interface QueryGroupType {
  month: string;
  total: string;
  type: string;
}

export interface IBaseStatisticsResponse {
  month: string;
}

export interface IOverviewStatisticsResponse extends IBaseStatisticsResponse {
  [OrderSource.Website]?: number;
  [OrderSource.CallIn]?: number;
  [OrderSource.Doordash]?: number;
  [OrderSource.Kiosk]?: number;
  [OrderSource.MPOS]?: number;
  [OrderSource.POS]?: number;
  [OrderSource.QR]?: number;
  [OrderSource.UberEats]?: number;
}

export interface ISegmentsStatisticsResponse extends IBaseStatisticsResponse {
  [GuestSegmentTypes.LOST]?: number;
  [GuestSegmentTypes.NEW]?: number;
  [GuestSegmentTypes.OCCASIONAL]?: number;
  [GuestSegmentTypes.REGULAR]?: number;
}

export interface IStatisticsResponse {
  stats: IOverviewStatisticsResponse[] | ISegmentsStatisticsResponse[];
}

export interface TopSellingItems {
  name: string;
  sales: string;
  previousSales: string;
  percentage: string;
}

export interface TopSellingChannels {
  name: string;
  sales: string;
  percentage: string;
  previousSales: string;
}

export interface TopSegments {
  name: string;
  lastCount: number;
  currentCount: number;
}
